import gsap from 'gsap'
import {useGSAP} from '@gsap/react'
import {useEffect, useRef} from 'react'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

export default function GAddClassOnScreenEnter({speed= 1, options = {}, scrollTrigger = {}, ...props}) {
  const wrapperRef = useRef(null)

  const addGSAPMotion = () => {
    let items = wrapperRef.current.querySelectorAll('.text-grad-grey, .text-grad-highlight')

    items.forEach(item => {
      gsap.to(item, {
        scrollTrigger: {
          trigger: item,
          scrub: 0,
          start: "top 85%",
          end: "bottom -50%",
          invalidateOnRefresh: true,
          onEnter: (e) => {
            e.trigger.classList.add("in-view")
          },
          onLeaveBack: (e) => {
            e.trigger.classList.remove("in-view")
          },


          ...scrollTrigger
        },

        ...options
      })

      gsap.fromTo(item, {
        y: -speed * 100,
      }, {
        y: speed * 100,
        scrollTrigger: {
          trigger: wrapperRef.current,
          scrub: 2,
          start: "top 100%",
          end: "100% 0%",
          invalidateOnRefresh: true,
          ...scrollTrigger
        }
      })
    })
  }

  useEffect(() => {
    addGSAPMotion()
  }, [props.children])

  useGSAP(() => {
    addGSAPMotion()
  })

  return (
    <div ref={wrapperRef}>{props.children}</div>
  )
}